import type { SVGProps } from 'react';

// Icons missing from iconoir, drawn to match its style (24px grid, 1.5 stroke,
// round caps, currentColor) and prop API.
function IconSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1.5em'
      height='1.5em'
      viewBox='0 0 24 24'
      fill='none'
      color='currentColor'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    />
  );
}

export function ChromeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconSvg {...props}>
      <circle cx='12' cy='12' r='10' />
      <circle cx='12' cy='12' r='4' />
      <path d='M21.17 8H12M3.95 6.06L8.54 14m2.34 7.94L15.46 14' />
    </IconSvg>
  );
}

export function AndroidIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconSvg {...props}>
      <path d='M4 10v6M20 10v6M7 9h10v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V9a5 5 0 0 1 10 0M8 3l1 2m7-2l-1 2M9 18v3m6-3v3' />
    </IconSvg>
  );
}

function Digits30() {
  return (
    <path d='M8 9h1.75a1.75 1.75 0 0 1 0 3.5 1.75 1.75 0 0 1 0 3.5H8M14.75 9a1.75 3.5 0 0 1 0 7 1.75 3.5 0 0 1 0-7' />
  );
}

export function Backward30Seconds(props: SVGProps<SVGSVGElement>) {
  return (
    <IconSvg {...props}>
      <path d='M3 13a9 9 0 1 0 9-9m0 0H4.5m0 0l2-2m-2 2l2 2' />
      <Digits30 />
    </IconSvg>
  );
}

export function Forward30Seconds(props: SVGProps<SVGSVGElement>) {
  return (
    <IconSvg {...props}>
      <path d='M21 13a9 9 0 1 1-9-9m0 0h7.5m0 0l-2-2m2 2l-2 2' />
      <Digits30 />
    </IconSvg>
  );
}
